// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cmpEntity from './entities/cmp.json';
import cmpMenu from '../pages/cmp/menu.json';
import cmpFullForm from '../pages/cmp/forms/full.json';
import cmpContextForm from '../pages/cmp/forms/context.json';
import cmpMiniForm from '../pages/cmp/forms/mini.json';
import cmpLookupForm from '../pages/cmp/forms/lookup.json';
import cmpTableView from '../pages/cmp/views/table.json';
import cmpStagesView from '../pages/cmp/views/stages.json';
import cmpCardsView from '../pages/cmp/views/cards.json';
import cmpInlineView from '../pages/cmp/views/inline.json';
import cmpBacklogView from '../pages/cmp/views/backlog.json';
import cmpSplitView from '../pages/cmp/views/split.json';
import cmpCalendarView from '../pages/cmp/views/calendar.json';
import cmpDashboardView from '../pages/cmp/views/dashboard.json';

/** Тип запису «Кампанія» зі сторінками пакета: меню, форми та подання з pages/cmp/. */
export const cmpDefinition: IRecordTypeDefinition = {
  ...cmpEntity,
  views: assembleViewSet({
      table: cmpTableView,
      stages: cmpStagesView,
      cards: cmpCardsView,
      inline: cmpInlineView,
      backlog: cmpBacklogView,
      split: cmpSplitView,
      calendar: cmpCalendarView,
      dashboard: cmpDashboardView,
  }),
  form: cmpFullForm,
  forms: { full: cmpFullForm, context: cmpContextForm, mini: cmpMiniForm, lookup: cmpLookupForm },
  menu: cmpMenu,
} as IRecordTypeDefinition;
